module.exports = __webpack_public_path__ + "static/media/demo.e1430503.gif";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/demo.gif
 ** module id = 162
 ** module chunks = 0
 **/